{
  "comingSoonText": "<p>您可能已经看到，从今天起至少一周内没有可用的预约时间。</p>\n<p>有时因取消会空出更早的时间。</p>\n<p>如果有更早的时间出现，您希望我们联系您吗？</p>\n<p>没有任何更改的压力 —— 如果当前时间适合您，完全可以保留它。</p>",
  "comingSoonTitle": "您愿意提前来看诊吗？",
  "contactConsent": {
    "no": "不，谢谢 – 我就按原定时间来",
    "yes": "是的 – 欢迎与我联系"
  },
  "contactConsentDetails": {
    "no": "我们不会就更早的时间与您联系。",
    "yes": "如果有更早的时间可用，我们会通知您。"
  },
  "description": "<p>您现在有时间直到 <strong>{{deadlineText}}</strong> 完成预约 —— 大约还有 <b>{{deadlineTime}} 小时</b>。</p>\n<span>完成预约，我们需要您：</span>\n<ul>\n  <li>确认或填写 <strong>患者信息</strong></li>\n  <li>告知我们 <strong>付款方</strong>（例如：保险）</li>\n  <li>回答一些 <strong>健康和偏好问题</strong></li>\n</ul>\n<p>整个流程通常少于 <strong>12 分钟</strong>。</p>",
  "nextLabel": "$t(common:next): <b>确认您的信息</b>",
  "text": "<p>您与 <strong>{{appointment.specialist}}</strong> 的 <strong>{{procedure.displayName}}</strong> 已于 <strong>{{appointment.date}}</strong> <strong>{{appointment.time}}</strong> <Status>临时预留</Status>。</p>",
  "title": "我们已为您预留了预约"
}
